<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getSelectedRouteGeoJson.data.id"
      :source="getSelectedRouteGeoJson"
      :layerId="getSelectedRouteLineLayer.id"
      :layer="getSelectedRouteLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getSelectedRouteGeoJson.data.id"
      :source="getSelectedRouteGeoJson"
      :layerId="getSelectedRoutePointsLayer.id"
      :layer="getSelectedRoutePointsLayer"
    />
  </div>
</template>
          
          <script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "SelectedRouteLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/routesModule", [
      "getSelectedRouteGeoJson",
      "getSelectedRouteLineLayer",
      "getSelectedRoutePointsLayer",
    ]),
  },
};
</script>